"use client";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import Image from "next/image";
import Slider from "react-slick";
import { useState } from "react";
import styled from "styled-components";

const SliderWrapper = styled.div`
  .slick-next,
  .slick-prev {
    display: none !important;
  }
  .slick-list {
    min-height: 540px;
  }
  .slick-slide {
    padding: 0 10px;
    height: 540px;
    > div {
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      max-height: 540px;
      max-width: 600px;
    }
  }
  .slick-dots {
    bottom: -100px;
    top: unset;
    width: 100%;
    display: flex !important;
    justify-content: center;
    gap: 8px;
    li {
      width: 90px;
      height: 90px;
      border: 1px solid #eaeaea;
      padding: 5px;
      margin: 0;
      border-radius: 6px;
      overflow: hidden;
      display: grid;
      place-items: center;
      &.slick-active {
        border-color: #0c2340;
      }
      img {
        max-height: 80px;
        object-fit: contain;
      }
    }
  }
`;

export function ImageViewer({ imageUrl, images, onClose }) {
  const initialIndex = images.findIndex((img) => img === imageUrl);
  const [currentImage, setCurrentImage] = useState(imageUrl);
  const settings = {
    customPaging: function (i) {
      return (
        <div>
          <Image
            src={images[i]}
            alt={`Thumbnail ${i + 1}`}
            width={50}
            height={50}
            className="object-contain"
            loading="eager"
          />
        </div>
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    afterChange: (index) => setCurrentImage(images[index]),
    initialSlide: initialIndex >= 0 ? initialIndex : 0,
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-[650px] min-h-[700px] rounded-[20px]">
        <SliderWrapper className="w-[600px] sm:w-[350px] h-[540px]">
          <Slider {...settings}>
            {images.map((img, index) => (
              <div key={index} className="relative h-[540px]">
                <Image
                  src={img}
                  alt={`Image ${index + 1}`}
                  fill
                  className="object-contain"
                  loading="eager"
                  quality={95}
                  sizes="(max-height: 400px) 100vw, 50vw"
                  unoptimized
                />
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      </DialogContent>
    </Dialog>
  );
}
